import "./notifications.css"
import "./notificationsList.css"
import AuthContext from "contexte/AuthContext"
import DashboardLayout from 'components/layout/dashboard/DashboardLayout'
import { useTranslation } from 'react-i18next'
import { useEffect, useState, useContext } from "react";
import PageLoader from "components/pageLoader/PageLoader";
import { useNavigate } from "react-router-dom"
import { deleteNotification, listNotifications } from "services/notificationsServices";
import { formatDate } from "utils/date";
import { launchError, launchSuccess } from "components/notifications";
import Notification from "components/notifications/Notification";
import Tableau from "components/DataComponents/Tableau/Tableau";
import ConfirmModal from "components/ConfirmModal/ConfirmModal";
import { NOTIFICATION_TYPES } from "./notificationTypes";


const NotificationsList = () => {

    const { user } = useContext(AuthContext);
    const { t } = useTranslation();
    const navigate = useNavigate();


    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [page, setPage] = useState(0);
    const [limit] = useState(10);
    const [toDelete, setToDelete] = useState(null);
    const [deleting, setDeleting] = useState(false);

    const fetchData = async () => {

        try {
            setError(false);
            const response = await listNotifications(user, page, limit);
            setNotifications(response);
        } catch (e) {
            console.error(e);
            setError(true);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchData();
    }, [page, limit])


    const handleDelete = async () => {
        try {
            setDeleting(true)
            await deleteNotification(user, toDelete._id)
            launchSuccess(t('notifications.notifications.delete.success'))
            setNotifications(prev => prev.filter(({ _id }) => _id !== toDelete._id));
        } catch (error) {
            launchError(t('notifications.notifications.delete.error'))
        } finally {
            setDeleting(false)
            setToDelete(null)
        }
    }

    const tbody = (notifications || []).map((item) => ({
        data: [
            <span className="notifications_list_title">{item.title}</span>,
            <span className="notifications_type_chip">{NOTIFICATION_TYPES[item.type] || item.type}</span>,
            <span className="notifications_num">{item.date ? formatDate({ date: item.date, time: true }) : '—'}</span>,
            <div className="notifications_row_actions">
                <button className="notifications_row_button" aria-label={`Modifier la notification « ${item.title} »`}
                    onClick={(e) => { e.stopPropagation(); navigate(`/notifications/${item._id}`) }}>
                    Modifier
                </button>
                <button className="notifications_row_button notifications_row_button_danger" aria-label={`Supprimer la notification « ${item.title} »`}
                    onClick={(e) => { e.stopPropagation(); setToDelete(item) }}>
                    Supprimer
                </button>
            </div>
        ],
        utils: { id: item._id }
    }))

    return (
        <DashboardLayout page={t('pages_name.notifications')}>
            <div className="notifications_page">
                <Notification />
                <div className="notifications_title_row">
                    <h1 className="notifications_page_title">Notifications</h1>
                    <button className="notifications_primary_button" onClick={() => navigate(`/notifications/new`)}>Nouvelle notification</button>
                </div>
                <p className="notifications_hint">Créez, programmez et modifiez les notifications push envoyées aux utilisateurs.</p>

                {
                    loading ? (
                        <div className='pageLoaderBox'>
                            <PageLoader />
                        </div>
                    ) : (
                        <div className="notifications_card">
                            {
                                error ? (
                                    <div className="notifications_empty notifications_empty_error" role="alert">
                                        <p className="notifications_empty_title">Erreur lors du chargement des notifications</p>
                                        <button className="notifications_secondary_button" onClick={fetchData}>Réessayer</button>
                                    </div>
                                ) : tbody.length || page > 0 ? (
                                    <div className="table-container">
                                        <div className="table-column">
                                            <Tableau
                                                thead={['Titre', 'Type', "Date d'envoi", 'Actions']}
                                                tbody={tbody}
                                            />
                                        </div>
                                        {(page > 0 || tbody.length >= limit) && (
                                            <nav className="notifications_pager" aria-label="Pagination">
                                                <button className="notifications_row_button" disabled={page === 0} onClick={() => setPage(page - 1)}>Précédent</button>
                                                <span className="notifications_num" aria-live="polite">Page {page + 1}</span>
                                                <button className="notifications_row_button" disabled={tbody.length < limit} onClick={() => setPage(page + 1)}>Suivant</button>
                                            </nav>
                                        )}
                                    </div>
                                ) : (
                                    <div className="notifications_empty">
                                        <p className="notifications_empty_title">Aucune notification</p>
                                        <p className="notifications_empty_hint">Créez une notification avec le bouton « Nouvelle notification ».</p>
                                    </div>
                                )
                            }
                        </div>
                    )
                }

                <ConfirmModal
                    isOpen={!!toDelete}
                    loading={deleting}
                    title="Supprimer la notification ?"
                    message={toDelete ? `La notification « ${toDelete.title} » sera supprimée définitivement.` : ''}
                    confirmLabel="Supprimer"
                    cancelLabel="Annuler"
                    onConfirm={handleDelete}
                    onClose={() => setToDelete(null)}
                />
            </div>

        </DashboardLayout>
    )
}

export default NotificationsList
